/**
 * Created by Ivan on 18.04.2024
 */

const StickersCollectionIcon = cc.Node.extend({
    ctor: function (collection) {
        this.collection = collection;
        this.isAvailable = this.collection.isAvailable();
        this._super();

        const styles = cleverapps.styles.StickersCollectionIcon;

        this.icon = this.createIcon(collection.index);

        if (this.isAvailable) {
            this.progress = this.createProgress();
        } else {
            this.availableText = this.createAvailableText();
        }

        const footNode = new cc.Node();
        footNode.setAnchorPoint(0.5, 0.5);
        footNode.setContentSize(styles.footnote.width, styles.footnote.height);
        footNode.addChild(this.progress || this.availableText);

        let underline;
        if (styles.underline) {
            underline = new cc.Sprite(bundles.stickers_book_window.frames.underline_collection_png);
            footNode.addChild(underline);
            underline.setAlignment(styles.underline);
        }

        this.content = new cleverapps.Layout([this.icon, footNode].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        if (collection.hasAttention()) {
            this.createBadge();
        }

        this.addChild(this.content);
        this.setContentSize(this.content.getContentSize());
        this.content.setAlignment(this.width / 2, this.height / 2);

        if (this.isAvailable) {
            cleverapps.UI.onClick(this, () => {
                cleverapps.tutorial.trigger("stickers_collection_icon_clicked");

                cleverapps.focusManager.display({
                    focus: "StickersCollectionWindow",
                    stack: true,
                    action: (f) => {
                        new StickersCollectionWindow(collection);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            });
        }

        this.collection.on("hideAttention", this.createListener(this.removeBadge.bind(this)));
        this.collection.on("update", this.createListener(this.updateProgress.bind(this)));
    },

    createIcon: function () {
        const styles = cleverapps.styles.StickersCollectionIcon;

        const icon = new cc.Node();
        icon.setAnchorPoint(0.5, 0.5);

        const bg = this.bg = new cleverapps.Spine(bundles.stickers_book_window.jsons.icon_border_json);
        bg.setAnimation(0, this.isAvailable ? "idle" : "close", false);

        icon.addChild(bg);
        icon.setContentSize(bg.getContentSize());
        bg.setAlignment(icon.width / 2, icon.height / 2);

        if (this.isAvailable) {
            const image = new cc.Sprite(this.collection.icon);
            icon.addChild(image);
            image.setAlignment(styles.icon);
        }

        if (styles.textBg) {
            const textBg = new cc.Scale9Sprite(bundles.stickers_book_window.frames.text_bg_png);
            textBg.setContentSize2(styles.textBg);
            icon.addChild(textBg);
            textBg.setAlignment(styles.textBg);
        }

        let titleFont = cleverapps.styles.FONTS.STICKERS_COLLECTION_TEXT;
        let opacity = 255;
        if (!this.isAvailable) {
            titleFont = cleverapps.styles.FONTS.STICKERS_COLLECTION_UNAVAILABLE_TEXT || titleFont;
            opacity = styles.title.unavailableOpacity || opacity;
        }

        const title = cleverapps.UI.generateOnlyText(Messages.get(this.collection.title), titleFont);
        title.setOpacity(opacity);

        icon.addChild(title);
        title.setAlignment(cleverapps.styles.StickersCollectionIcon.title);
        title.fitTo(styles.title.maxWidth, styles.title.maxHeight);

        return icon;
    },

    createAvailableText: function () {
        const styles = cleverapps.styles.StickersCollectionIcon.availableText;
        const availableLevel = this.collection.getAvailableLevel();
        const text = cleverapps.UI.generateOnlyText(Messages.get("StickersCollectionWindow.AvailableText", { level: availableLevel }), cleverapps.styles.FONTS.STICKERS_AVAILABLE_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.width, styles.height);
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles);

        return text;
    },

    createProgress: function () {
        const styles = cleverapps.styles.StickersCollectionIcon.prizebar;

        if (this.collection.isPrizeCollected) {
            const checkmark = new cc.Sprite(bundles.stickers_book_window.frames.checkmarks_png);
            checkmark.setAlignment(styles.checkmark);
            return checkmark;
        }

        const currentValue = this.collection.getOpenedStickersAmount(true);
        const goalValue = StickersCollection.STICKERS_IN_COLLECTION;

        if (currentValue === goalValue) {
            const button = new cleverapps.UI.Button({
                type: cleverapps.styles.UI.Button.Images.small_button_green,
                width: styles.button.width,
                height: styles.button.height,
                text: Messages.get("Claim.Button"),
                onClicked: function () {
                    this.collection.onPrizeCollect();
                    cleverapps.focusManager.currentWindow().close();

                    cleverapps.focusManager.display({
                        focus: "StickersCompletedWindow",
                        stack: true,
                        action: function (f) {
                            new StickersCompletedWindow(this.collection.index);
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }.bind(this)
                    });
                }.bind(this)
            });
            button.setAlignment(styles.button);
            return button;
        }

        let progress;
        if (styles.width) {
            progress = this.progress = new PrizeBarComponent({
                reward: StickersBook.getCollectionReward(this.collection.index),
                progressBar: {
                    progressImage: bundles.stickers_book_window.frames.collection_progress_bar_png,
                    progressBgImage: bundles.stickers_book_window.frames.collection_progress_bar_bg_png,
                    width: styles.width,
                    barText: {
                        dy: styles.text.dy
                    },
                    removeBarText: styles.removeBarText

                },
                prizePosition: styles.prizePosition
            });
            progress.updateProgress(currentValue, goalValue);
            if (this.collection.isPrizeCollected) {
                this.progress.setCollected();
            }

            this._prizeBarComponent = progress;
        } else {
            progress = this.progress = cleverapps.UI.generateOnlyText(`${currentValue}/${goalValue}`, cleverapps.styles.FONTS.STICKERS_BOOK_WHITE_FONT);
            this._prizeBarComponent = undefined;
        }

        progress.setAlignment(styles);
        return progress;
    },

    setPrizeBarTooltipEnabled: function (enabled) {
        if (this._prizeBarComponent) {
            this._prizeBarComponent.setTooltipEnabled(enabled);
        }
    },

    updateProgress: function (animated) {
        if (this.collection.jokerAnimationActive) {
            return;
        }

        const currentProgress = this.collection.getOpenedStickersAmount(true);
        const goalProgress = StickersCollection.STICKERS_IN_COLLECTION;

        if (currentProgress < goalProgress) {
            if (this.progress instanceof PrizeBarComponent) {
                this.progress.updateProgress(currentProgress, goalProgress, {
                    animated
                });
            } else {
                this.progress.setString(`${currentProgress}/${goalProgress}`);
            }

            return;
        }

        const parent = this.progress.parent;
        this.progress.removeFromParent();
        this.progress = this.createProgress();
        parent.addChild(this.progress);
    },

    collect: function (callback) {
        if (!this.collection.isCollected()) {
            const progressBefore = this.collection.getOpenedStickersAmount(true) - 1;

            if (this.progress instanceof PrizeBarComponent) {
                this.progress.updateProgress(progressBefore, StickersCollection.STICKERS_IN_COLLECTION);
            } else {
                this.progress.setString(`${progressBefore}/${StickersCollection.STICKERS_IN_COLLECTION}`);
            }
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(cleverapps.styles.StickersCollectionIcon.collectAnimation.duration),
            new cc.CallFunc(() => {
                this.bg.setAnimation(0, "open", false);
            }),
            new cc.ScaleTo(0.25, 1.2).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.25, 1).easing(cc.easeBounceOut()),
            new cc.CallFunc(() => {
                this.collection.jokerAnimationActive = false;
                this.updateProgress(true);
                callback();
            })
        ));
    },

    updateBadge: function () {
        if (this.collection.hasAttention() && !this.badge) {
            this.createBadge();
        } else if (!this.collection.hasAttention() && this.badge) {
            this.badge.removeFromParent();
            this.badge = undefined;
        }
    },

    createBadge: function () {
        const styles = cleverapps.styles.StickersCollectionIcon.badge;

        const badge = this.badge = new cc.Sprite(bundles.stickers_book_window.frames.collection_badge_png);
        badge.setLocalZOrder(10);

        if (styles.text) {
            const text = cleverapps.UI.generateOnlyText(Messages.get("Attention.Text"), cleverapps.styles.FONTS.COLLECTION_BADGE_TEXT);
            badge.addChild(text);
            text.setAlignment(styles.text);
            text.fitTo(styles.text.maxWidth);
            text.setRotation(styles.text.rotation);
        }

        this.addChild(badge);
        badge.setAlignment(styles);
    },

    removeBadge: function () {
        if (!this.badge) {
            return;
        }
        this.badge.removeFromParent();
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STICKERS_BOOK_WHITE_FONT: {
        color: cleverapps.styles.COLORS.WHITE,
        size: 40,
        stroke: cleverapps.styles.DECORATORS.WHITE_TEXT_SHADOW
    }
});

cleverapps.styles.StickersCollectionIcon = {
    footnote: {
        width: 200,
        height: 100
    },
    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 10 }
    },

    textBg: {
        width: 220,
        height: 60,
        x: { align: "center" },
        y: { align: "bottom" }
    },

    availableText: {
        x: { align: "center" },
        y: { align: "center" },
        width: 220,
        height: 90
    },

    title: {
        maxWidth: 190,
        maxHeight: 50,
        x: { align: "center" },
        y: { align: "bottom", dy: 11 },
        unavailableOpacity: 170
    },

    prizebar: {
        x: { align: "center" },
        y: { align: "center" },
        width: 160,
        text: {
            dy: 0
        },
        checkmark: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -8 }
        },
        button: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -8 },
            width: 200,
            height: 70
        }
    },
    margin: 0,

    badge: {
        x: { align: "right", dx: 30 },
        y: { align: "top", dy: 20 },
        text: {
            x: { align: "center" },
            y: { align: "center" },
            maxWidth: 70,
            rotation: 20
        }
    },

    collectAnimation: {
        duration: 3.5
    },

    underline: undefined
};